<script setup>
import { watchEffect } from 'vue'
import { Card, Toggle, Hints, Suggestions } from '@components'
import DarkModeStore from '@o/store'
const { options } = DarkModeStore()

</script>
<template>
    <section>
        <Card borderless transparent class="gap-5" style="min-height: calc(100vh - 360px) !important">
            <Card>
                <Toggle v-model="options.admin_enabled">Enable Admin Dashboard Dark Mode</Toggle>
                <Hints>Turn it ON to enable dark mode on the WordPress dashboard</Hints>
            </Card>
            
            <Card>
                <Toggle v-model="options.admin_enabled_block_editor">Block Editor Dark Mode</Toggle>
                <Hints>Turn it ON to show dark mode switch in the block editor for toggling between dark and light mode.</Hints>
            </Card>
        </Card>
        <Suggestions paths="shortcode, excludes"></Suggestions>
    </section>
</template> 